import { Box, Checkbox, FormControlLabel, useTheme } from '@mui/material';

import type { Annotation, FormAttributeValue } from '@verantos-dev/core-annotation-tool';

import { AttributeInput } from './AttributeInput';
import { SupportedIndirectlyCheckbox } from './SupportedIndirectlyCheckbox';

export type HandleChangeAttribute = (
  attributeName: string,
  payload: Partial<{
    value: unknown;
    isUnknown: boolean;
    supportedIndirectly: boolean;
  }>
) => void;

interface AttributeRowProps {
  attribute: any;
  annotation: Annotation | null;
  isRequired: boolean;
  isDisabled: boolean;
  isSupportedIndirectlyDisabled: boolean;
  attributeRule: any;
  onChange: (name: string, updates: Partial<FormAttributeValue>) => void;
}

export const AttributeRow = ({
  attribute,
  annotation,
  isRequired,
  isDisabled,
  isSupportedIndirectlyDisabled,
  attributeRule,
  onChange,
}: AttributeRowProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: theme.spacing(1),
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        px: theme.spacing(2),
        width: '100%',
      }}
    >
      <AttributeInput
        attribute={attribute}
        attributeRule={attributeRule}
        isDisabled={isDisabled}
        onChange={onChange}
      />
      <Box sx={{ display: 'flex', gap: theme.spacing(1), justifyContent: 'space-between' }}>
        {attributeRule.hasUnknownOption && (
          <FormControlLabel
            sx={{
              margin: 0,
              '& .MuiFormControlLabel-label': {
                fontSize: 14,
              },
            }}
            control={
              <Checkbox
                checked={attribute.isUnknown || false}
                onChange={(e) =>
                  onChange(attribute.name, {
                    isUnknown: e.target.checked,
                    value: e.target.checked ? undefined : attribute.value,
                  })
                }
                sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    width: 18,
                    height: 18,
                  },
                }}
              />
            }
            label="Unknown"
          />
        )}

        <SupportedIndirectlyCheckbox
          attribute={attribute}
          annotation={annotation}
          disabled={isDisabled || isSupportedIndirectlyDisabled}
          onChange={onChange}
        />
      </Box>
    </Box>
  );
};
